import { memo, useEffect, useState } from 'react'
import { Box } from '@chakra-ui/react'
import { useAIChat } from '../../../../contexts/AIChatContext'
import { useProjectSources } from '../../../../api/api_hooks/project-sources'
import axiosClient from '../../../../api/axios'
import { ProjectChatInterface } from './ProjectChatInterface'

interface ChatViewProps {
  projectId: string
  projectName?: string
  articleCount?: number
}

export const ChatView = memo(function ChatView({ projectId, projectName, articleCount }: ChatViewProps) {
  const { setContext } = useAIChat()

  const { data: sourcesData } = useProjectSources(projectId)
  const [articlesCount, setArticlesCount] = useState(0)

  // Fetch project articles count
  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axiosClient.get(`/medinsight/projects/${projectId}/articles`)
        setArticlesCount(response.data.articles?.length || 0)
      } catch (error) {
        console.error('Error fetching articles:', error)
      }
    }
    fetchArticles()
  }, [projectId])

  // Calculate total sources
  const sourcesCount = sourcesData?.sources?.length || 0
  const totalSources = sourcesCount + articlesCount

  // Set project context for AI chat (for the floating chat in other contexts)
  useEffect(() => {
    setContext({
      type: 'project',
      projectId,
      projectName,
      articleCount,
      sourceCount: totalSources,
    })

    // Reset to general context when unmounting
    return () => {
      setContext({ type: 'general' })
    }
  }, [projectId, projectName, articleCount, totalSources, setContext])

  return (
    <Box h="full">
      <ProjectChatInterface
        projectId={projectId}
        projectName={projectName}
        sourceCount={totalSources}
      />
    </Box>
  )
})
